var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8706 5.82241H16.6092V2.88157C15.7675 2.79404 14.9216 2.75082 14.0753 2.7521C11.5599 2.7521 9.83978 4.28726 9.83978 7.09862V9.52157H7.00067V12.8138H9.83978V21.2479H13.243V12.8138H16.0729L16.4983 9.52157H13.243V7.4223C13.243 6.45127 13.502 5.82241 14.8706 5.82241Z",
    fill: "#1E1E2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.417f3ee2dc21f130bc8d86f5093c7381.svg";
export { ForwardRef as ReactComponent };